import { useEffect } from 'react';

export const useKeyboardShortcuts = (shortcuts) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // Ignoruj shortcuts pokud je fokus v input fieldu
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }

      const key = event.key.toLowerCase();
      const combo = [];
      
      if (event.ctrlKey) combo.push('ctrl');
      if (event.altKey) combo.push('alt');
      if (event.shiftKey) combo.push('shift');
      combo.push(key);
      
      const comboString = combo.join('+');
      
      if (shortcuts[comboString]) {
        event.preventDefault();
        shortcuts[comboString]();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [shortcuts]);
};

export const SHORTCUTS = {
  ADD_COMPANY: 'ctrl+n',
  DASHBOARD: 'ctrl+d',
  SEARCH: 'ctrl+f',
  EXPORT_CSV: 'ctrl+e',
  OVERDUE_FILTER: 'ctrl+1',
  TODAY_FILTER: 'ctrl+2',
  COMPLETED_FILTER: 'ctrl+3',
  CLEAR_FILTERS: 'ctrl+0'
};
